var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrowdSurfingLeftPinkGopher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "matrix(0.591716, 0, 0, 0.591716, 0, 0)",
      transformOrigin: "50% 50%",
      cursor: "move",
      transition: "transform 200ms ease-in-out"
    },
    width: 957,
    height: 789,
    viewBox: "0 0 9570 7890",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l78dabwa6Oj6k4r0s4Ab4XM",
    fill: "rgb(0,0,0)",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pcGE8rLuF",
    d: "M5235 7883 c-184 -15 -389 -35 -430 -43 -27 -5 -90 -17 -140 -26 -485 -88 -926 -251 -1325 -492 -76 -46 -117 -65 -122 -58 -5 7 -8 5 -8 -6 0 -10 -30 -38 -73 -67 -337 -227 -687 -585 -931 -951 -211 -318 -416 -733 -517 -1050 l-41 -129 -96 -30 c-192 -60 -458 -170 -629 -261 -479 -254 -813 -580 -898 -874 -27 -92 -18 -225 20 -300 41 -81 110 -141 192 -166 166 -51 240 -26 776 269 241 132 286 154 273 133 -8 -14 -54 -231 -61 -294 -4 -32 -10 -58 -14 -58 -6 0 -7 -13 -10 -315 -3 -214 12 -386 50 -568 43 -213 152 -498 253 -663 l25 -41 -72 -53 c-92 -68 -249 -227 -306 -308 -24 -34 -48 -62 -52 -62 -5 0 -8 -3 -7 -8 0 -4 -15 -41 -34 -82 -107 -227 -97 -454 27 -606 109 -133 330 -184 520 -120 149 51 258 121 404 261 64 62 162 171 207 234 2 2 45 -23 96 -56 606 -390 1341 -586 2197 -585 393 0 651 25 991 95 l65 14 23 -86 c42 -158 139 -323 242 -414 24 -21 77 -54 118 -74 165 -79 375 -47 482 74 43 49 85 132 101 201 31 129 5 359 -63 552 l-33 95 110 79 c97 69 155 117 284 231 37 33 202 220 242 275 190 258 336 609 424 1015 14 66 35 157 47 203 l21 83 34 -48 c19 -26 82 -120 140 -208 182 -275 307 -420 441 -509 224 -148 463 -73 528 166 72 267 -116 766 -460 1222 -96 127 -250 315 -268 327 -5 3 -10 16 -13 29 -3 17 23 62 103 179 163 236 264 402 342 563 74 154 142 343 160 449 6 35 13 73 15 84 2 11 4 26 4 33 1 7 22 -17 47 -55 123 -179 301 -347 429 -404 170 -75 360 -22 435 121 44 85 55 233 26 365 -47 219 -191 534 -343 752 -35 51 -64 95 -64 97 0 15 -203 209 -259 248 -74 52 -182 109 -253 132 -42 14 -157 35 -193 36 -7 0 -35 41 -63 91 -225 395 -598 744 -1041 972 -531 273 -1098 396 -1815 394 -121 -1 -238 -2 -260 -4z m646 -198 c432 -41 801 -129 1127 -271 70 -30 132 -56 137 -57 6 -1 12 -4 15 -7 3 -3 52 -32 110 -65 368 -207 644 -457 858 -777 40 -59 72 -109 72 -112 0 -3 16 -33 36 -66 39 -66 74 -90 136 -90 58 0 169 -29 236 -60 208 -97 419 -337 572 -651 66 -136 137 -332 161 -448 14 -68 6 -150 -17 -187 -10 -15 -36 -35 -58 -44 -34 -16 -44 -17 -83 -5 -166 50 -384 310 -612 728 l-42 77 -58 0 c-86 0 -87 -3 -71 -170 27 -287 -25 -529 -180 -835 -88 -176 -148 -273 -300 -491 -62 -87 -140 -204 -175 -259 -196 -312 -319 -663 -425 -1205 -16 -85 -35 -173 -41 -195 l-12 -40 -19 69 c-72 263 -255 477 -505 593 -271 125 -664 122 -948 -6 l-65 -30 0 187 c0 475 -42 781 -132 970 -40 82 -150 197 -225 236 -103 51 -263 70 -394 46 -174 -32 -344 -180 -457 -398 -51 -98 -104 -239 -137 -367 -30 -114 -75 -396 -75 -469 l0 -49 -47 45 c-128 119 -314 212 -516 260 -76 17 -125 21 -282 22 -121 1 -217 -4 -265 -13 -169 -30 -379 -116 -505 -206 -69 -50 -197 -179 -242 -245 -52 -76 -111 -204 -133 -286 -40 -147 -44 -441 -10 -569 29 -105 42 -137 52 -124 7 10 7 7 3 -8 -8 -28 54 -151 120 -238 101 -134 254 -266 406 -349 85 -46 205 -90 339 -124 94 -23 124 -26 290 -27 252 0 367 24 575 124 215 103 388 273 494 487 43 86 91 230 91 271 0 24 1 25 18 11 58 -51 181 -88 296 -88 l61 0 2 -109 c7 -421 291 -786 703 -904 114 -33 289 -51 425 -43 134 8 132 5 -60 -89 -161 -79 -304 -135 -460 -181 -121 -35 -425 -101 -500 -108 -22 -2 -110 -12 -195 -22 -189 -21 -608 -24 -810 -5 -374 35 -717 103 -989 196 -40 13 -77 22 -82 19 -5 -3 -9 -1 -9 5 0 5 -17 15 -37 22 -75 23 -310 132 -418 191 -208 115 -377 235 -540 384 -42 38 -81 68 -86 66 -6 -1 -8 2 -5 7 3 5 -20 38 -52 73 -170 188 -312 419 -407 661 -189 484 -196 1050 -18 1529 23 63 28 69 81 98 31 17 100 49 152 71 122 52 130 59 130 125 0 69 -15 78 -119 72 -174 -11 -384 -108 -1091 -502 -91 -51 -189 -97 -237 -113 l-83 -25 -47 23 c-68 35 -88 67 -88 142 2 240 351 599 819 843 269 140 671 287 931 340 104 21 115 31 115 105 0 76 -17 89 -117 89 -49 0 -73 4 -73 12 0 22 112 293 179 433 221 461 527 881 857 1175 57 51 100 98 97 103 -3 6 -1 7 6 3 7 -4 31 9 59 31 54 45 168 128 229 168 24 15 40 32 36 38 -3 5 -2 7 4 4 6 -4 59 23 119 59 417 251 931 425 1469 499 273 37 660 45 936 20z m-702 -3381 c94 -28 174 -121 187 -218 5 -35 2 -52 -17 -85 -27 -49 -48 -64 -119 -85 -102 -30 -195 -16 -317 48 -38 20 -84 52 -101 69 l-32 33 31 50 c60 95 148 166 238 190 61 17 69 17 130 -2z m2812 -835 c262 -318 442 -643 515 -928 39 -151 30 -223 -35 -291 -44 -47 -66 -49 -134 -17 -53 24 -162 115 -195 162 -12 17 -36 46 -54 65 -39 41 -28 25 -187 261 -68 101 -153 221 -188 267 -34 45 -63 87 -63 92 0 23 101 315 120 347 11 19 20 40 20 46 0 7 16 44 37 82 l36 68 21 -25 c12 -14 60 -72 107 -129z m-2796 -112 c33 -15 63 -33 67 -40 4 -7 8 -40 8 -74 l0 -61 -52 13 c-28 8 -102 20 -165 26 -111 13 -113 13 -113 38 0 40 19 98 37 117 26 26 143 15 218 -19z m-1555 -36 c324 -72 559 -260 716 -573 30 -59 70 -133 90 -164 l36 -56 -10 -102 c-25 -232 -124 -426 -294 -574 -322 -281 -762 -323 -1158 -111 -266 143 -442 373 -496 647 -25 130 -12 258 42 400 100 267 375 479 697 537 109 20 277 18 377 -4z m1429 -317 c119 -17 256 -60 343 -106 66 -35 138 -102 138 -127 0 -21 -50 -98 -84 -130 l-26 -24 -48 46 c-56 51 -97 74 -197 108 -64 22 -85 24 -255 23 -161 0 -193 -3 -249 -22 -36 -11 -68 -19 -73 -16 -8 5 -78 138 -78 149 0 13 99 67 150 82 121 35 226 40 379 17z m1424 -58 c316 -93 514 -317 558 -631 32 -224 -81 -511 -273 -691 -198 -187 -519 -298 -765 -264 -222 30 -432 142 -555 294 -109 135 -174 320 -166 466 5 76 28 140 51 140 21 0 87 50 106 80 9 16 51 51 92 78 137 90 219 209 228 336 l6 70 80 43 c205 110 434 138 638 79z m-4824 -1326 l51 -70 -99 -97 c-120 -119 -161 -180 -161 -239 0 -58 19 -74 84 -74 66 0 110 27 246 151 l101 91 67 -63 c37 -35 68 -67 70 -70 5 -12 -220 -239 -286 -288 -86 -63 -175 -108 -256 -128 -58 -14 -68 -14 -120 1 -106 31 -180 125 -181 230 0 34 4 78 8 99 6 30 5 37 -4 31 -8 -4 -10 -3 -5 5 4 6 11 9 15 7 4 -3 13 12 21 32 22 63 90 170 159 250 68 79 207 202 227 202 6 0 35 -31 63 -70z m4625 -905 c55 -179 60 -309 16 -395 -58 -116 -127 -143 -247 -98 -109 40 -225 188 -274 350 -13 43 -14 60 -6 64 24 8 112 34 119 34 4 0 13 -19 20 -42 14 -48 53 -110 94 -151 22 -22 36 -27 75 -27 71 0 89 19 89 95 0 33 -7 88 -16 120 -29 108 -32 99 33 126 39 17 60 22 65 15 5 -6 19 -47 32 -91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11lUYJGPP",
    d: "M5682 7018 c-17 -17 -15 -94 4 -131 9 -18 35 -59 58 -92 151 -224 308 -523 375 -717 44 -128 81 -287 81 -346 0 -66 -27 -137 -64 -170 -49 -43 -66 -45 -130 -21 -164 61 -377 262 -563 531 -33 48 -64 84 -68 80 -5 -4 -5 -2 -2 4 4 7 -17 53 -47 103 -29 50 -59 104 -66 121 -7 16 -17 27 -23 23 -6 -3 -7 -1 -3 5 8 13 -18 78 -41 104 -11 13 -31 18 -64 18 -62 0 -74 -19 -66 -106 20 -213 221 -575 449 -807 207 -212 392 -305 588 -295 70 3 94 9 140 33 56 31 125 108 114 127 -4 6 -2 8 3 5 26 -16 52 107 53 241 1 366 -237 896 -549 1224 -71 76 -75 78 -120 78 -26 0 -52 -5 -59 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMDEW7Pq1",
    d: "M2969 2737 c-28 -22 -39 -55 -39 -122 0 -120 53 -235 159 -348 110 -116 242 -194 382 -223 107 -23 351 -15 432 14 162 59 289 157 343 267 22 46 26 65 22 112 -7 78 -35 103 -120 103 l-61 0 -74 -79 c-126 -135 -282 -192 -435 -159 -102 22 -197 71 -271 138 -66 61 -103 120 -132 210 -27 85 -46 100 -124 100 -36 0 -73 -6 -82 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peanCLDHQ",
    d: "M5635 2365 c-22 -21 -25 -33 -25 -101 0 -69 4 -86 37 -153 56 -113 160 -214 283 -275 136 -66 199 -80 355 -80 210 0 335 47 469 175 87 82 127 155 133 242 3 50 0 68 -16 95 -20 31 -22 32 -94 32 -83 0 -83 0 -149 -100 -92 -137 -272 -212 -428 -176 -166 37 -301 149 -351 290 -21 58 -50 76 -126 76 -55 0 -67 -4 -88 -25z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ldImWJwcksprxJzo00uzLt",
    fill: "rgb(227,81,66)",
    style: {
      transform: "none"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pqlYnPxxS",
    d: "M5019 4336 c-100 -27 -197 -112 -257 -224 l-32 -59 49 -46 c54 -51 150 -103 226 -123 100 -27 264 -11 330 32 12 8 32 32 44 55 20 35 23 51 19 113 -6 86 -29 136 -91 193 -72 67 -179 89 -288 59z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l6OMghZntJj98xcx2nmFyg",
    fill: "rgb(196,127,125)",
    style: {
      transform: "none"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pOf6ofRyf",
    d: "M5135 7719 c-975 -77 -1865 -493 -2457 -1146 -211 -233 -395 -494 -540 -763 -73 -136 -173 -347 -180 -380 -2 -8 -6 -17 -9 -20 -11 -9 -91 -224 -93 -247 0 -13 -4 -23 -7 -23 -4 0 -9 -8 -12 -19 -4 -17 1 -18 79 -13 99 6 134 -9 134 -57 0 -41 -25 -57 -115 -75 -260 -53 -662 -200 -931 -340 -381 -199 -710 -497 -792 -718 -37 -100 -37 -98 -4 -98 24 0 53 22 153 116 172 162 264 237 409 336 332 226 678 395 1085 528 141 46 230 87 256 116 10 11 27 55 39 99 31 111 68 201 150 366 135 268 340 570 542 794 35 39 87 98 116 132 121 138 374 351 584 492 488 325 1052 526 1678 597 213 25 640 25 835 1 297 -36 651 -129 950 -249 172 -69 419 -199 552 -289 23 -16 44 -29 46 -29 3 0 16 -9 29 -20 12 -10 66 -55 118 -98 153 -127 269 -259 400 -452 90 -133 161 -190 288 -230 210 -67 319 -131 458 -269 100 -99 175 -199 276 -369 106 -178 109 -182 141 -182 27 0 28 2 22 33 -13 62 -78 223 -138 342 -147 295 -358 531 -559 625 -67 31 -178 60 -236 60 -57 0 -98 24 -128 77 -16 26 -32 50 -36 51 -4 2 -8 10 -8 17 0 19 -132 217 -200 300 -76 93 -239 256 -325 326 -483 391 -1052 604 -1794 674 -176 16 -597 19 -776 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17o4lwQT6",
    d: "M5512 7117 c-36 -21 -54 -55 -59 -117 -8 -80 12 -116 148 -275 214 -252 342 -432 454 -640 26 -49 56 -102 67 -117 10 -14 18 -35 18 -47 0 -21 27 -41 55 -41 23 0 16 39 -40 206 -69 210 -206 472 -393 758 -29 44 -55 90 -58 103 -7 26 10 53 33 53 18 0 9 56 -14 82 -39 44 -158 64 -211 35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj5ZWOw5I",
    d: "M7808 3605 c-37 -75 -41 -88 -28 -98 21 -17 186 -227 252 -322 161 -231 322 -539 422 -808 20 -52 36 -102 36 -111 0 -24 37 -20 51 6 21 39 23 179 4 265 -65 293 -257 640 -549 993 -154 186 -137 179 -188 75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbvXd7taB",
    d: "M6200 838 c-76 -38 -98 -58 -62 -58 23 0 61 -87 107 -249 34 -117 30 -168 -20 -264 -19 -37 -35 -75 -35 -82 0 -31 66 -7 106 37 79 86 98 237 55 428 -12 53 -59 199 -69 214 -5 7 -33 -2 -82 -26z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l3wyB2nLfbBy1o4XSzdJaQ1",
    fill: "rgb(255,167,159)",
    style: {
      transform: "none"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pftjX1sx1",
    d: "M5270 7723 c0 -5 106 -8 235 -8 129 0 235 3 235 8 0 4 -106 7 -235 7 -129 0 -235 -3 -235 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pl2mjlNlt",
    d: "M5750 7722 c0 -10 227 -28 236 -19 3 2 -35 8 -83 11 -48 4 -103 10 -120 13 -19 3 -33 1 -33 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pD2N5JKy1",
    d: "M4920 7690 c0 -7 14 -8 38 -4 51 9 53 14 4 14 -23 0 -42 -5 -42 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5uRQVRTG",
    d: "M4035 7475 c-25 -12 -26 -14 -5 -9 28 7 60 23 45 23 -5 0 -23 -6 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6nWMEmw4",
    d: "M5390 7444 c-434 -39 -678 -84 -973 -180 -143 -47 -308 -110 -317 -122 -3 -4 -13 -8 -22 -10 -28 -4 -217 -95 -330 -157 -128 -71 -347 -217 -453 -302 -121 -97 -306 -267 -367 -336 -29 -34 -81 -93 -116 -132 -202 -224 -407 -526 -542 -794 -82 -165 -119 -255 -150 -366 -12 -44 -29 -88 -39 -99 -26 -29 -115 -70 -256 -116 -407 -133 -753 -302 -1085 -528 -143 -97 -240 -176 -390 -318 -58 -54 -116 -108 -129 -119 l-24 -20 7 25 c6 19 5 21 -3 10 -6 -8 -15 -39 -22 -68 -13 -63 1 -137 34 -178 26 -34 91 -63 139 -64 67 0 191 48 348 136 553 309 743 404 918 464 154 52 232 51 232 -4 0 -33 -23 -50 -130 -95 -52 -22 -121 -54 -152 -71 -53 -29 -58 -35 -81 -98 -88 -237 -130 -479 -130 -757 -1 -522 148 -971 452 -1370 65 -85 171 -200 182 -198 5 2 9 -3 9 -10 0 -15 146 -146 254 -228 98 -74 267 -180 277 -173 5 3 9 1 9 -5 0 -12 136 -86 277 -149 383 -173 795 -274 1313 -323 168 -16 678 -17 820 -1 204 23 289 35 285 42 -2 4 6 5 18 3 31 -6 297 49 442 91 223 65 454 166 642 279 177 107 185 120 57 86 -43 -11 -95 -22 -114 -24 -148 -14 -199 -15 -295 -5 -320 35 -577 186 -742 437 -105 161 -154 321 -154 508 l0 113 -53 -5 c-112 -12 -241 29 -333 103 l-42 34 -7 -47 c-10 -75 -52 -201 -95 -287 -106 -214 -279 -385 -494 -487 -207 -99 -314 -123 -540 -122 -157 0 -179 2 -285 30 -153 41 -261 83 -358 142 -45 27 -84 46 -87 43 -3 -3 -5 0 -5 5 0 6 -21 27 -47 46 -62 45 -170 156 -228 232 -67 87 -141 245 -170 360 -22 84 -26 122 -26 240 0 138 7 195 38 305 18 63 81 194 126 260 45 66 173 195 242 245 126 90 336 176 505 206 119 22 374 17 487 -10 212 -49 399 -146 538 -280 69 -67 85 -64 85 16 0 81 44 358 75 478 49 188 130 379 211 492 185 262 470 352 717 227 75 -39 185 -154 225 -236 91 -190 132 -495 132 -980 0 -109 4 -198 9 -198 4 0 46 18 92 39 474 222 1031 92 1292 -302 83 -125 142 -288 154 -426 5 -58 8 -69 15 -51 18 50 70 268 99 418 38 202 98 436 147 582 109 318 197 485 442 834 152 218 212 315 300 491 122 242 176 435 187 665 3 72 1 165 -6 219 -13 105 -8 121 40 121 24 0 33 -9 70 -77 119 -220 206 -352 316 -485 171 -206 314 -287 428 -244 108 42 126 167 59 401 -31 107 -44 134 -41 88 1 -18 5 -33 10 -33 4 0 7 -7 7 -16 0 -24 -25 11 -107 151 -104 176 -187 287 -287 386 -139 138 -248 202 -458 269 -127 40 -198 97 -288 230 -127 187 -245 322 -390 444 -101 86 -145 117 -154 111 -3 -3 -4 -2 -1 2 17 22 -354 228 -583 323 -132 56 -493 172 -514 167 -10 -3 -16 -1 -12 4 3 5 3 9 0 9 -3 0 -72 13 -153 30 -233 47 -382 61 -673 65 -146 1 -285 1 -310 -1z m286 -379 c20 -15 33 -34 32 -43 -2 -12 5 -18 22 -20 50 -7 210 -188 329 -372 175 -271 321 -679 321 -899 0 -169 -61 -291 -173 -348 -135 -68 -320 -21 -518 131 -46 35 -88 62 -94 59 -5 -4 -7 -3 -3 2 4 4 -25 42 -64 84 -164 175 -304 394 -383 601 -62 161 -66 246 -12 238 19 -3 81 -78 71 -87 -6 -6 83 -170 148 -276 266 -426 619 -712 778 -630 41 21 76 72 91 128 21 85 -3 300 -34 294 -6 -1 -13 9 -15 23 -2 14 -12 36 -21 50 -10 14 -40 66 -66 115 -112 208 -240 388 -454 640 -127 148 -156 198 -146 247 21 95 110 125 191 63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqO7OtOSF",
    d: "M5756 6815 c-3 -8 0 -15 7 -15 7 0 33 -32 57 -71 59 -92 79 -117 44 -54 -29 53 -94 155 -99 155 -2 0 -5 -7 -9 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZ4ERBicQ",
    d: "M5941 6530 c18 -33 34 -59 35 -57 5 4 -56 117 -62 117 -3 0 9 -27 27 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwtmpolYK",
    d: "M5990 6446 c0 -11 50 -106 55 -106 3 0 -7 24 -21 53 -28 55 -34 65 -34 53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CezT9IaR",
    d: "M6062 6295 c-1 -13 66 -153 67 -140 0 6 -15 42 -34 80 -18 39 -33 66 -33 60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pyXbSV95r",
    d: "M6151 6060 c1 -18 37 -119 38 -107 2 16 -22 102 -30 112 -6 5 -9 3 -8 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYuxwO87z",
    d: "M3740 7350 c-19 -11 -30 -19 -25 -19 6 0 26 8 45 19 19 11 31 19 25 19 -5 0 -26 -8 -45 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pG1SiqYjD",
    d: "M3618 7289 c-43 -21 -78 -41 -78 -44 0 -3 36 13 80 35 44 22 80 42 80 45 0 7 4 8 -82 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDBokdTee",
    d: "M7395 7253 c6 -6 46 -34 90 -63 44 -29 117 -82 163 -117 45 -35 82 -62 82 -59 0 8 -158 128 -240 183 -86 57 -110 71 -95 56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2yU4mkoB",
    d: "M3293 7099 c-33 -21 -40 -29 -25 -29 8 1 70 50 62 50 -3 0 -20 -10 -37 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSMlDCde9",
    d: "M3113 6969 c-29 -22 -53 -42 -53 -45 0 -6 40 22 85 60 47 40 25 30 -32 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV8QTLgo2",
    d: "M7770 6977 c0 -1 35 -36 78 -77 l77 -75 -75 78 c-69 71 -80 82 -80 74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnYPSua7Z",
    d: "M2979 6859 l-44 -41 48 37 c43 34 53 45 43 45 -2 0 -23 -18 -47 -41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNFAyOIl1",
    d: "M2810 6703 l-115 -118 118 115 c64 63 117 116 117 117 0 8 -13 -5 -120 -114z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14eh3nRoC",
    d: "M7980 6763 c1 -4 19 -28 42 -53 43 -47 34 -29 -14 28 -16 18 -28 29 -28 25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1EBawsUGi",
    d: "M2614 6498 c-36 -39 -82 -97 -58 -73 27 26 106 115 102 115 -2 0 -22 -19 -44 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paXwAOf27",
    d: "M2520 6388 c-29 -44 -32 -53 -6 -23 22 26 32 45 23 45 -1 0 -9 -10 -17 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pwIl3bxvH",
    d: "M8270 6333 c0 -5 12 -20 28 -34 l27 -24 -25 30 c-14 17 -26 32 -27 34 -2 2 -3 0 -3 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p773tmh3B",
    d: "M2380 6200 c-22 -33 -38 -60 -36 -60 3 0 24 27 46 60 22 33 38 60 36 60 -3 0 -24 -27 -46 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppWquIgyb",
    d: "M8680 6187 c0 -3 33 -28 73 -57 39 -29 66 -46 59 -38 -14 17 -132 102 -132 95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXmNk1p1s",
    d: "M8885 6009 c2 -24 29 -48 41 -36 5 4 -3 19 -17 33 l-26 25 2 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11XLug7lU",
    d: "M8940 5963 c1 -4 19 -28 42 -53 43 -47 34 -29 -14 28 -16 18 -28 29 -28 25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9zfFwJ9w",
    d: "M2140 5810 c-11 -22 -18 -40 -15 -40 2 0 14 18 25 40 11 22 18 40 15 40 -2 0 -14 -18 -25 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDGfC5Z1Q",
    d: "M9136 5665 c-3 -9 0 -15 9 -15 8 0 15 -4 15 -8 0 -5 7 -17 15 -28 10 -11 8 -2 -5 24 -23 47 -25 49 -34 27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pV1KUkxg6",
    d: "M1946 5401 c-11 -17 -27 -66 -19 -56 12 13 34 65 28 65 -2 0 -6 -4 -9 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMMQDp1tF",
    d: "M1891 5269 c-6 -18 -9 -34 -7 -36 2 -2 9 10 15 28 6 18 9 34 7 36 -2 2 -9 -10 -15 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pvXhSPg19",
    d: "M2050 5023 c0 -6 -15 -18 -32 -27 -18 -8 -26 -16 -17 -16 22 0 66 36 57 46 -5 4 -8 3 -8 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppm5ag0gK",
    d: "M827 4535 c-20 -14 -37 -28 -37 -31 0 -2 18 8 40 22 35 23 47 34 37 34 -1 0 -19 -11 -40 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pg2rvexK8",
    d: "M743 4479 c-35 -22 -46 -37 -15 -20 22 13 58 40 52 41 -3 0 -20 -10 -37 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pqVmT1hNY",
    d: "M532 4315 c-40 -36 -69 -65 -65 -65 9 1 151 130 143 130 -3 0 -38 -29 -78 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prLcml9RG",
    d: "M359 4143 c-32 -36 -53 -63 -47 -63 2 0 21 20 41 45 42 49 45 61 6 18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FVL8B0li",
    d: "M7850 3673 c0 -13 5 -23 12 -23 7 0 25 -12 42 -27 33 -30 18 -7 -26 42 -27 29 -28 29 -28 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZEisEI6t",
    d: "M7785 3558 c-68 -146 -86 -193 -124 -310 -56 -178 -59 -195 -32 -221 33 -33 105 -134 230 -320 67 -99 117 -165 123 -161 7 4 8 2 4 -4 -9 -15 34 -73 47 -65 6 3 7 1 4 -4 -9 -14 93 -134 106 -126 6 3 7 1 4 -4 -9 -14 93 -107 142 -132 118 -61 183 -47 246 52 16 24 16 27 1 21 -11 -4 -16 -1 -16 11 0 46 -125 342 -224 530 -136 258 -329 543 -470 693 -27 29 -29 35 -19 62 18 48 5 34 -22 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p18YPubN0l",
    d: "M7953 3562 c-7 -5 -3 -11 13 -19 23 -11 24 -10 13 5 -8 9 -14 18 -14 19 0 1 -6 -1 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pb8n0yWq1",
    d: "M8049 3453 c18 -24 35 -43 38 -43 7 0 -34 55 -54 71 -10 8 -3 -5 16 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgpAxNJU9",
    d: "M8134 3330 c0 -10 8 -21 18 -23 14 -4 16 -2 8 13 -15 27 -26 31 -26 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Att4brLs",
    d: "M8215 3224 c10 -17 26 -41 37 -55 l20 -24 -17 31 c-10 17 -26 41 -37 55 l-20 24 17 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3NGFBdoo",
    d: "M8287 3096 c-4 -9 -1 -16 5 -16 6 0 17 -8 24 -17 7 -10 13 -13 13 -8 1 6 -8 21 -18 34 -15 20 -19 21 -24 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pZ54Qow5f",
    d: "M8345 3010 c9 -16 18 -30 21 -30 2 0 -2 14 -11 30 -9 17 -18 30 -21 30 -2 0 2 -13 11 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13Ihq3dUp",
    d: "M8553 2410 c0 -36 2 -50 4 -32 2 17 2 47 0 65 -2 17 -4 3 -4 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP9rTXMXx",
    d: "M1531 1690 c-112 -85 -274 -264 -283 -315 -1 -5 -10 -18 -19 -29 -10 -10 -31 -53 -46 -95 -24 -64 -28 -91 -28 -176 0 -91 3 -104 27 -146 100 -171 308 -183 543 -31 66 43 295 262 342 327 l21 30 -99 93 -99 94 -105 -99 c-119 -111 -206 -173 -240 -173 -25 0 -55 24 -55 44 0 30 71 120 177 224 l115 112 -34 38 c-18 20 -53 65 -77 100 -24 34 -47 62 -52 62 -4 0 -44 -27 -88 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHTYr6uYI",
    d: "M6245 855 c-19 -16 -19 -16 2 -6 32 16 36 14 31 -13 -3 -15 0 -27 8 -30 8 -3 14 -12 14 -20 0 -8 4 -17 9 -21 6 -3 2 18 -8 47 -20 58 -28 65 -56 43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GUgYYDV3",
    d: "M6140 809 c-24 -11 -46 -22 -48 -24 -2 -2 8 -39 22 -83 37 -111 44 -177 21 -202 -10 -11 -28 -20 -40 -20 -43 0 -124 105 -146 189 -9 38 -17 50 -28 47 -113 -33 -191 -58 -191 -63 0 -4 9 -41 21 -82 50 -182 165 -335 284 -381 101 -38 207 -27 256 27 l24 27 -33 -27 c-19 -15 -37 -27 -42 -27 -5 0 6 28 23 62 30 57 32 68 32 162 -1 95 -3 109 -49 236 -26 74 -49 145 -49 158 -2 26 0 26 -57 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdnmoUC9q",
    d: "M6317 711 c-3 -12 1 -22 9 -25 16 -6 18 12 5 32 -6 11 -9 9 -14 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p09mhHTI0",
    d: "M6364 470 c0 -52 1 -74 3 -47 2 26 2 68 0 95 -2 26 -3 4 -3 -48z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l4T8ra3o5mhirFmi7u68LAh",
    fill: "rgb(242,223,164)",
    style: {
      transform: "none"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pwQgikDpb",
    d: "M9331 4857 c-29 -35 -30 -38 -7 -17 24 22 52 60 44 60 -2 0 -18 -19 -37 -43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15TQu6nen",
    d: "M7992 4203 c-26 -38 -34 -53 -29 -53 2 0 16 18 31 40 29 45 28 56 -2 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3i8O1kAz",
    d: "M1430 4105 c-14 -8 -20 -14 -15 -14 6 0 21 6 35 14 14 8 21 14 15 14 -5 0 -21 -6 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBzAcaXSy",
    d: "M1000 3885 c-14 -8 -20 -14 -15 -14 6 0 21 6 35 14 14 8 21 14 15 14 -5 0 -21 -6 -35 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "px1mzv9Sk",
    d: "M877 3818 c-31 -17 -56 -33 -54 -34 4 -5 117 56 117 62 0 6 -1 6 -63 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Awjkusvb",
    d: "M635 3680 c-16 -11 -25 -20 -20 -20 10 0 64 39 55 40 -3 0 -18 -9 -35 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJQKwZOFD",
    d: "M523 3628 c-18 -6 -33 -15 -33 -19 0 -9 47 8 65 23 11 9 10 9 -32 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phl1NJ8Y9",
    d: "M4765 3040 c-127 -19 -257 -81 -263 -126 -2 -12 19 -63 45 -115 55 -107 48 -105 163 -63 70 26 85 28 235 28 148 0 165 -2 234 -27 102 -37 152 -68 203 -127 l44 -50 40 28 c74 54 130 150 119 203 -9 38 -72 99 -143 137 -176 94 -470 143 -677 112z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdNmBpNiT",
    d: "M5955 925 c-25 -12 -26 -14 -5 -9 28 7 60 23 45 23 -5 0 -23 -6 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pDXGB96qd",
    d: "M1198 905 c6 -11 21 -29 34 -40 22 -19 22 -19 -2 10 -40 48 -43 51 -32 30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pkPg0BW0r",
    d: "M1640 860 c-30 -16 -51 -29 -47 -30 10 0 107 49 107 55 0 7 1 7 -60 -25z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l7YAYfP7jc9G6cAkvWLjOAm",
    fill: "rgb(255,255,255)",
    style: {
      transform: "none"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1GYRwsuPW",
    d: "M5810 6958 c24 -27 45 -48 47 -48 8 0 0 9 -44 50 l-48 45 45 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FLawbjqs",
    d: "M5984 6747 c16 -20 30 -37 33 -37 7 0 -36 58 -49 66 -7 4 1 -9 16 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "piLB9Ljzn",
    d: "M5084 6476 c-3 -8 -4 -25 -2 -38 3 -17 5 -13 9 15 5 38 2 47 -7 23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HoZ22HsN",
    d: "M5275 6270 c9 -16 18 -30 21 -30 2 0 -2 14 -11 30 -9 17 -18 30 -21 30 -2 0 2 -13 11 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOwnPKpff",
    d: "M5339 6165 c5 -11 17 -29 26 -40 l16 -20 -10 20 c-5 11 -17 29 -26 40 l-16 20 10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pX65YGLUA",
    d: "M5385 6090 c42 -77 214 -287 312 -380 65 -62 65 -62 -13 20 -101 107 -166 185 -234 280 -55 77 -80 108 -65 80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BvSTJDUa",
    d: "M6321 6080 c0 -8 4 -24 9 -35 5 -13 9 -14 9 -5 0 8 -4 24 -9 35 -5 13 -9 14 -9 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pYNL2kIBm",
    d: "M6362 5925 c0 -11 4 -31 8 -45 6 -20 8 -21 8 -5 0 11 -4 31 -8 45 -6 20 -8 21 -8 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ewg8Eks6",
    d: "M5370 5830 c12 -16 24 -30 26 -30 3 0 -4 14 -16 30 -12 17 -24 30 -26 30 -3 0 4 -13 16 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1AJEILvs5",
    d: "M5438 5743 c17 -21 49 -56 73 -78 23 -22 11 -5 -27 38 -73 82 -95 101 -46 40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pEcTQ8lIq",
    d: "M6223 5735 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pWQfsTLyf",
    d: "M5801 5618 c36 -33 119 -84 119 -74 0 3 -13 12 -29 20 -15 8 -50 31 -77 51 -49 36 -49 36 -13 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pM0YzW2Hn",
    d: "M5590 5587 c0 -2 15 -16 33 -33 l32 -29 -29 33 c-28 30 -36 37 -36 29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3dzzlJyM",
    d: "M6165 5541 c-6 -6 -23 -17 -40 -25 -16 -9 -23 -16 -15 -16 14 0 82 49 70 50 -4 0 -10 -4 -15 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKtdrqq7t",
    d: "M8555 5520 c9 -16 18 -30 21 -30 2 0 -2 14 -11 30 -9 17 -18 30 -21 30 -2 0 2 -13 11 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pnSzhm295",
    d: "M5664 5522 c8 -13 66 -56 66 -49 0 3 -17 17 -37 33 -20 15 -33 23 -29 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pikuWQSap",
    d: "M8600 5440 c11 -22 23 -40 25 -40 3 0 -4 18 -15 40 -11 22 -23 40 -25 40 -3 0 4 -18 15 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CqA8nILK",
    d: "M5800 5425 c0 -7 61 -37 66 -33 2 3 -12 12 -31 21 -19 9 -35 15 -35 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgxYOcXTf",
    d: "M8433 5370 c0 -36 2 -50 4 -32 2 17 2 47 0 65 -2 17 -4 3 -4 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6yUCyhzC",
    d: "M6235 5394 c-18 -16 -22 -22 -9 -15 18 9 53 42 43 41 -2 -1 -17 -12 -34 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15lRVUwRG",
    d: "M6037 5343 c18 -2 50 -2 70 0 21 2 7 4 -32 4 -38 0 -55 -2 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pI8bn7E2h",
    d: "M8670 5326 c0 -9 99 -156 106 -156 2 0 -19 35 -47 78 -60 89 -59 88 -59 78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p3blWxMkL",
    d: "M8423 5185 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pETSDSttL",
    d: "M8789 5143 c5 -10 22 -29 37 -43 24 -22 23 -20 -6 18 -35 44 -47 54 -31 25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DuV6aSnL",
    d: "M9369 4990 c-3 -47 -9 -94 -12 -105 -4 -11 0 -5 8 13 11 23 15 56 13 105 l-3 72 -6 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pMaTmL7m8",
    d: "M8935 4971 c22 -23 58 -57 80 -74 47 -36 35 -23 -55 58 -46 43 -54 47 -25 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p14AhJbmKu",
    d: "M8366 4924 c-10 -31 -16 -58 -14 -60 3 -2 12 21 22 52 10 31 16 58 14 60 -3 2 -12 -21 -22 -52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "paFbQLKdU",
    d: "M8322 4795 c-17 -37 -14 -45 4 -12 9 16 14 31 11 33 -2 2 -9 -7 -15 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1CiFeG0kT",
    d: "M8267 4670 c-19 -44 -33 -80 -31 -80 7 0 76 152 71 156 -2 2 -20 -32 -40 -76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6BrAxUPN",
    d: "M8185 4510 c-9 -16 -13 -30 -11 -30 3 0 12 14 21 30 9 17 13 30 11 30 -3 0 -12 -13 -21 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1GNK83Kj2",
    d: "M5073 4503 c20 -2 54 -2 75 0 20 2 3 4 -38 4 -41 0 -58 -2 -37 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "penYpBWx5",
    d: "M5259 4479 c30 -10 56 -17 58 -15 5 5 -86 36 -101 35 -6 0 13 -9 43 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAPyYRJ6o",
    d: "M8128 4413 c-19 -32 -42 -70 -52 -85 -10 -16 -16 -28 -13 -28 5 0 73 104 96 148 24 45 2 20 -31 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HUvla3Us",
    d: "M5592 4159 c6 -16 12 -28 14 -26 5 5 -13 57 -20 57 -3 0 0 -14 6 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puO7IQI3V",
    d: "M1575 4165 c-25 -12 -26 -14 -5 -9 28 7 60 23 45 23 -5 0 -23 -6 -40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p13Zd4Py0d",
    d: "M4512 4035 c-17 -37 -14 -45 4 -12 9 16 14 31 11 33 -2 2 -9 -7 -15 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12QQcVYMQ",
    d: "M1223 4008 c-13 -6 -23 -15 -23 -19 0 -4 14 -1 30 7 29 15 39 25 23 23 -5 0 -18 -5 -30 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6CUr0Irs",
    d: "M1120 3950 c-19 -11 -31 -19 -27 -20 11 0 67 29 67 35 0 7 -1 7 -40 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pgcO6TRUr",
    d: "M7814 3948 c-4 -7 -14 -24 -22 -38 -14 -24 -13 -24 3 -5 20 24 37 55 31 55 -3 0 -8 -6 -12 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHpNc0fSl",
    d: "M818 3784 c-38 -20 -36 -28 2 -9 17 9 30 18 30 20 0 7 -1 6 -32 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pylxbyAT9",
    d: "M7705 3769 c-9 -17 -15 -33 -13 -35 3 -2 12 12 21 31 21 43 13 47 -8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5erVfmAq",
    d: "M1436 3744 c-4 -14 -5 -28 -3 -31 3 -2 8 8 11 23 4 14 5 28 3 31 -3 2 -8 -8 -11 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pItTNne6e",
    d: "M705 3720 c-38 -22 -66 -40 -62 -40 11 0 137 70 137 76 0 6 -1 6 -75 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn8P5PWcr",
    d: "M5693 3635 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUXkJUhcW",
    d: "M465 3605 c-16 -8 -23 -14 -15 -14 8 0 29 6 45 14 17 7 23 13 15 13 -8 0 -28 -6 -45 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9WMTllnr",
    d: "M264 3596 c11 -9 27 -16 35 -15 14 0 14 1 1 6 -8 3 -24 10 -35 15 -20 9 -20 9 -1 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peHSbqbWA",
    d: "M1397 3581 c-4 -18 -7 -43 -6 -55 1 -11 5 -1 10 24 5 25 7 49 6 55 -2 5 -7 -5 -10 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFEiqMv3k",
    d: "M7597 3555 c-24 -50 -20 -58 4 -12 11 22 19 41 17 43 -3 2 -12 -12 -21 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pozXq9sPH",
    d: "M338 3573 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1BjFhM64B",
    d: "M3403 3543 c32 -2 81 -2 110 0 29 2 3 3 -58 3 -60 0 -84 -1 -52 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pELavNiPM",
    d: "M3613 3533 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15TtTfrKq",
    d: "M3170 3520 c-20 -6 -21 -8 -5 -8 11 0 31 4 45 8 20 6 21 8 5 8 -11 0 -31 -4 -45 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p8sNX5v8c",
    d: "M3775 3500 c11 -5 27 -9 35 -9 9 0 8 4 -5 9 -11 5 -27 9 -35 9 -9 0 -8 -4 5 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FM2WRzy4",
    d: "M1382 3470 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pruaUA8Qq",
    d: "M7551 3444 c-12 -31 -20 -59 -18 -61 2 -2 14 22 26 53 12 31 20 59 18 61 -2 2 -14 -22 -26 -53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCYuN0dB5",
    d: "M5704 3275 c0 -121 2 -169 3 -107 2 62 2 161 0 220 -1 59 -3 8 -3 -113z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pHI3Eywjr",
    d: "M3899 3459 c24 -11 46 -18 48 -15 4 4 -73 36 -85 35 -4 0 13 -9 37 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pfaozA28f",
    d: "M1373 3385 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pErcmeRzV",
    d: "M4947 3405 c-19 -18 -33 -67 -42 -145 l-7 -56 120 -12 c66 -7 152 -22 191 -32 39 -11 75 -20 81 -20 12 0 14 189 2 207 -4 7 -34 25 -67 40 -51 24 -76 28 -161 31 -83 3 -104 1 -117 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1HO4aBQrd",
    d: "M2773 3359 c-35 -22 -46 -37 -15 -20 22 13 58 40 52 41 -3 0 -20 -10 -37 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pTDqKQDrZ",
    d: "M3395 3373 c-148 -8 -315 -47 -419 -100 -158 -80 -305 -208 -379 -330 -149 -245 -155 -583 -16 -832 148 -264 380 -430 714 -512 131 -33 342 -32 475 0 176 44 309 111 434 219 188 163 285 367 302 633 l6 106 -36 57 c-20 31 -60 105 -90 164 -153 304 -386 495 -695 569 -72 17 -217 29 -296 26z m-288 -675 c11 -13 28 -48 38 -78 29 -90 66 -149 132 -210 102 -93 244 -150 380 -150 154 0 276 54 386 171 81 87 110 98 160 59 40 -31 43 -72 12 -135 -53 -110 -181 -209 -342 -267 -81 -28 -271 -36 -372 -14 -140 30 -272 107 -382 223 -177 188 -215 421 -68 423 24 0 42 -7 56 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pb0OwvZUp",
    d: "M2684 3294 l-39 -35 43 32 c38 30 48 39 39 39 -2 0 -21 -16 -43 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7TvxJbFh",
    d: "M4333 3290 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p9Uo28hXb",
    d: "M1364 3140 c0 -91 2 -128 3 -82 2 45 2 119 0 165 -1 45 -3 8 -3 -83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pVL3gSJKV",
    d: "M4270 3225 c19 -19 36 -35 39 -35 3 0 -10 16 -29 35 -19 19 -36 35 -39 35 -3 0 10 -16 29 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXhhrkcFW",
    d: "M2594 3218 l-29 -33 33 29 c17 17 32 31 32 33 0 8 -8 1 -36 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DhWkXXQc",
    d: "M6243 3183 c26 -2 68 -2 95 0 26 2 4 3 -48 3 -52 0 -74 -1 -47 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pP13RpScQ",
    d: "M6680 3105 c14 -8 30 -14 35 -14 6 0 -1 6 -15 14 -14 8 -29 14 -35 14 -5 0 1 -6 15 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p5q170rWO",
    d: "M2488 3093 c-18 -21 -31 -43 -25 -43 2 0 13 14 25 30 25 33 24 41 0 13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOCxlBbav",
    d: "M6110 2996 c-108 -20 -194 -50 -285 -99 l-80 -43 -6 -70 c-9 -127 -91 -246 -228 -336 -41 -27 -83 -62 -92 -78 -19 -30 -85 -80 -106 -80 -50 0 -70 -213 -34 -364 51 -213 191 -392 390 -495 233 -121 493 -142 749 -59 349 111 571 347 648 688 22 98 25 130 20 215 -7 126 -27 209 -77 310 -92 189 -260 324 -486 391 -108 32 -295 41 -413 20z m-329 -655 c13 -10 30 -36 38 -57 71 -198 304 -329 529 -297 138 20 242 82 310 183 61 92 70 100 119 100 38 0 46 -4 63 -32 40 -64 -6 -173 -116 -277 -127 -121 -261 -174 -439 -175 -124 0 -199 19 -325 80 -75 38 -109 62 -170 123 -132 132 -187 285 -125 346 30 31 82 33 116 6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peeYBMbbS",
    d: "M7670 2980 c11 -16 26 -33 32 -36 7 -4 -1 9 -16 29 -34 44 -46 50 -16 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJwSGcXdJ",
    d: "M1373 2890 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pexagf5o4",
    d: "M7730 2900 c12 -16 24 -30 26 -30 3 0 -4 14 -16 30 -12 17 -24 30 -26 30 -3 0 4 -13 16 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pps1ZvPnl",
    d: "M6990 2904 c0 -6 17 -26 38 -45 l37 -34 -35 40 c-19 22 -36 42 -37 44 -2 2 -3 0 -3 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6GM2EXRp",
    d: "M7785 2823 c15 -24 30 -43 32 -43 7 0 -31 61 -46 73 -8 7 -2 -7 14 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzYqbUt3A",
    d: "M7131 2710 c12 -22 24 -38 26 -36 4 4 -37 76 -44 76 -2 0 6 -18 18 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcBCNMGVq",
    d: "M7920 2620 c22 -33 43 -60 46 -60 2 0 -14 27 -36 60 -22 33 -43 60 -46 60 -2 0 14 -27 36 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBcpMwhPU",
    d: "M2303 2510 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pu3PSf47i",
    d: "M8005 2503 c19 -27 51 -66 71 -88 31 -34 32 -35 9 -5 -14 19 -44 59 -66 88 -22 28 -42 52 -44 52 -3 0 11 -21 30 -47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1ECqoBxzo",
    d: "M2312 2380 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pApYEHKjO",
    d: "M7250 2325 c0 -27 3 -45 7 -42 7 8 6 77 -2 85 -3 3 -5 -16 -5 -43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puSDm18eE",
    d: "M8170 2305 c19 -19 36 -35 39 -35 3 0 -10 16 -29 35 -19 19 -36 35 -39 35 -3 0 10 -16 29 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pcg3qRqyU",
    d: "M4957 2203 c18 -2 50 -2 70 0 21 2 7 4 -32 4 -38 0 -55 -2 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pBXAxxC2H",
    d: "M1698 1940 c46 -76 144 -208 197 -265 53 -56 52 -55 -9 19 -36 43 -93 120 -127 170 -65 95 -98 136 -61 76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pCm6OB0Qi",
    d: "M2490 1920 c12 -16 24 -30 26 -30 3 0 -4 14 -16 30 -12 17 -24 30 -26 30 -3 0 4 -13 16 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pQDQrynCV",
    d: "M2620 1765 c19 -19 36 -35 39 -35 3 0 -10 16 -29 35 -19 19 -36 35 -39 35 -3 0 10 -16 29 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p53xuHvPV",
    d: "M4355 1728 l-60 -63 63 60 c58 55 67 65 59 65 -1 0 -29 -28 -62 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "puXlkbQUK",
    d: "M5151 1745 c0 -5 6 -21 14 -35 8 -14 14 -20 14 -15 0 6 -6 21 -14 35 -8 14 -14 21 -14 15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p7W6vYZKY",
    d: "M1700 1630 c11 -16 26 -33 32 -36 7 -4 -1 9 -16 29 -34 44 -46 50 -16 7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peMHdNF92",
    d: "M1749 1568 c7 -10 11 -25 7 -33 -7 -19 -2 -19 13 -2 8 11 6 18 -11 33 -18 15 -20 16 -9 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p11VPPfDZ9",
    d: "M2050 1515 c30 -30 57 -55 59 -55 3 0 -19 25 -49 55 -30 30 -57 55 -59 55 -3 0 19 -25 49 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUKFSi19T",
    d: "M1635 1418 l-90 -93 93 90 c50 49 92 91 92 92 0 8 -12 -4 -95 -89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAWaEtpZ6",
    d: "M5345 1450 c27 -27 51 -50 54 -50 3 0 -17 23 -44 50 -27 28 -51 50 -54 50 -3 0 17 -22 44 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p49phjkJS",
    d: "M2120 1457 c0 -2 15 -16 33 -33 l32 -29 -29 33 c-28 30 -36 37 -36 29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pXF7LL6zq",
    d: "M3448 1393 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf1sYsPd6",
    d: "M5460 1351 c19 -17 39 -31 44 -31 5 0 7 1 5 3 -2 2 -22 15 -44 31 l-40 27 35 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1LidYDOs",
    d: "M1765 1318 l-40 -43 43 40 c39 36 47 45 39 45 -2 0 -21 -19 -42 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pSI46t0NF",
    d: "M2303 1306 c15 -14 33 -26 39 -26 13 0 14 0 -32 29 l-35 23 28 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pbxrVCdJ3",
    d: "M1191 1269 c-6 -18 -9 -34 -7 -36 2 -2 9 10 15 28 6 18 9 34 7 36 -2 2 -9 -10 -15 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "poHGdOqH4",
    d: "M2377 1259 c12 -15 73 -53 73 -46 0 2 -19 17 -42 32 -24 16 -38 22 -31 14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pNoJiPoZm",
    d: "M5600 1265 c0 -7 61 -37 66 -33 2 3 -12 12 -31 21 -19 9 -35 15 -35 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pzNGFC24v",
    d: "M6460 1202 c-8 -4 -16 -14 -18 -22 -3 -11 2 -10 17 4 28 26 29 30 1 18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p95hBxGr8",
    d: "M6098 1143 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pjlnvZnH0",
    d: "M1905 1058 l-80 -83 83 80 c76 74 87 85 79 85 -1 0 -38 -37 -82 -82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGfk29MbK",
    d: "M2580 1135 c0 -2 23 -16 50 -30 28 -14 50 -23 50 -20 0 2 -22 16 -50 30 -27 14 -50 23 -50 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pAZ9MqtMC",
    d: "M6343 1119 c-35 -22 -46 -37 -15 -20 22 13 58 40 52 41 -3 0 -20 -10 -37 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pUMWZAGot",
    d: "M2740 1055 c0 -7 61 -37 66 -33 2 3 -12 12 -31 21 -19 9 -35 15 -35 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p61NdrgEk",
    d: "M6158 1014 c-27 -13 -48 -27 -48 -29 0 -3 23 6 50 20 28 14 50 28 50 30 0 7 1 7 -52 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1DVU9YSVN",
    d: "M1780 949 c-35 -31 -35 -31 -3 -9 18 11 35 25 38 30 10 16 2 11 -35 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17jS1HguF",
    d: "M3020 932 c8 -5 26 -13 40 -16 17 -5 20 -4 10 2 -8 5 -26 13 -40 16 -17 5 -20 4 -10 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pJ9PZAxhC",
    d: "M1700 895 c-19 -14 -29 -25 -23 -25 7 0 25 11 40 25 36 31 28 31 -17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pp5mL37tP",
    d: "M5775 859 c-27 -10 -37 -17 -21 -14 31 7 97 33 81 33 -5 0 -32 -8 -60 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGPLDaMKq",
    d: "M1585 835 c-16 -8 -23 -14 -14 -15 8 0 24 7 35 15 23 18 18 18 -21 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pKpEHHgRm",
    d: "M3465 795 c22 -8 49 -13 60 -13 11 0 -2 6 -30 14 -63 17 -84 16 -30 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p12rGOIPcH",
    d: "M3580 770 c14 -4 36 -8 50 -8 22 0 22 1 -5 8 -16 4 -39 8 -50 8 -16 0 -15 -2 5 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "plkiPBX83",
    d: "M3853 723 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pFfZPewUQ",
    d: "M5013 703 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pdfLb1feH",
    d: "M4133 693 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prKh4mFY7",
    d: "M4933 693 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1Ac2OnD7U",
    d: "M4288 683 c23 -2 59 -2 80 0 20 2 1 4 -43 4 -44 0 -61 -2 -37 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6X4yv1GK",
    d: "M4747 683 c18 -2 50 -2 70 0 21 2 7 4 -32 4 -38 0 -55 -2 -38 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p6aoXDubI",
    d: "M4528 673 c23 -2 59 -2 80 0 20 2 1 4 -43 4 -44 0 -61 -2 -37 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p15QHIBgtS",
    d: "M5761 550 c0 -8 6 -28 14 -45 17 -39 18 -21 0 25 -7 19 -14 28 -14 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pOX8mG62g",
    d: "M5790 466 c0 -11 40 -86 45 -86 3 0 -4 19 -16 43 -23 45 -29 54 -29 43z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrowdSurfingLeftPinkGopher);
export default __webpack_public_path__ + "static/media/crowd_surfing_left_pink_gopher.fc3c99ff6bda3859616d3a6b398ce1ca.svg";
export { ForwardRef as ReactComponent };